import styled from "styled-components";

export const BenifitMdlCont = styled.div`
  width: 530px;
  border-radius: 16px;
  background-color: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
  @media (max-width: 768px) {
    width: 100%;
    border-radius: 0;
    left: 0;
    top: unset;
    bottom: 0;
    transform: none;
  }
`;
export const BenifitMdlHdr = styled.div`
  padding: 24px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px rgba(0,0,0,0.2) solid;
  @media (max-width: 768px) {
    border-bottom: 0;
    padding: 24px  24px 10px 24px;
  }
`;
export const BenifitMdlHdng = styled.h4`
  font-size: 20px;
  line-height: 24px;
  color: #141823;
  font-weight: 900;
`;
export const BenifitMdlClose = styled.button`
  width: 20px;
  height: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  border: 0;
  cursor: pointer;
  background: transparent;
  &:before, 
  &:after {
    position: absolute;
    left: 10px;
    top: 0;
    content: ' ';
    height: 20px;
    width: 2px;
    background-color: #979797;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
export const BenifitMdlBody = styled.div`
  padding: 16px 30px;
  @media (max-width: 768px) {
    padding: 16px 24px;
  }
`;
export const BenifitMdlBackdrop = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: rgba(0,0,0,0.5);
`;
export const BenifitMdlList = styled.ul`
  li{
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 20px;
    position: relative;
    display: flex;
    align-items: center;
    @media (max-width: 768px) {
      margin-bottom: 16px;
    }
    &::before{
      content: "";
      width: 12px;
      height: 12px;
      background: linear-gradient(63.16deg, #43E1A8 0%, #219393 56%);
      border-radius: 50%;
      flex-shrink: 0;
      margin-right: 16px;
    }
  }
`;
